<script>
	// Stores
	import ExoticBetStore from '@/Stores/Racing/ExoticBetStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	import Modal from '@/Components/ModalFlex.svelte';
	// Partials
	import BetTickerRow from '@/Partials/Bets/_BetTickerRow.svelte';
	import PillMultiSelect from '@/Components/PillMultiSelect.svelte';
	//Constants
	import { BetTypeNames, ExoticBetTypes } from '@/Constants/Bet.js';

	export let open;
	export let meeting;
	export let race;

	$: links = open && $ExoticBetStore.count() && paginationBuilder(ExoticBetStore.getPagination());
	$: open && getExoticBets();

	let pageNo = getUrlParameter('page') || 1;
	let pageSize = 50;
	//   let loading = getExoticBets();
	let loading = false;
	let betTypeFilter = null;
	let selectedOptions = []; // Track selected options

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getExoticBets();
			setUrlParameter('page', pageNo);
		}
	}

	function updateFilter(e) {
		// Update betTypeFilter based on selection
		const selected = e.detail.checked;
		betTypeFilter = selected[0] === undefined ? null : selected;
	}

	async function applyFilter() {
		await getExoticBets();
	}

	function resetFilter() {
		selectedOptions = [];
		betTypeFilter = null;
		applyFilter();
	}

	async function getExoticBets() {
		loading = true;
		try {
			const bets = await ExoticBetStore.getExoticBetsForRace(
				race.id,
				{ size: pageSize, number: pageNo },
				betTypeFilter
			);
			console.log('Loaded bets:', bets);
		} catch (error) {
			console.error('Error loading exotic bets:', error);
		} finally {
			loading = false;
		}
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)} className="mx-2 md:w-full max-h-full overflow-y-auto">
		<div>
			<div>
				<!-- Page Header -->
				<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
					<div class="flex items-center justify-between w-full">
						<h1 class="text-xl font-bold">
							{meeting && meeting.name} Race {race && race.race_number} - Exotic Bets
						</h1>
					</div>
				</div>
				<!-- /Page Header -->
				<div class="p-2 mx-4 bg-gray-100 rounded">
					<div class="flex items-center space-x-2 w-full p-4 text-sm md:py-2">
						<PillMultiSelect
							className="min-w-24"
							name="bet_type_filter"
							label="Bet Type"
							on:change={updateFilter}
							bind:checked={selectedOptions}
							options={[...ExoticBetTypes.map((betType) => [betType, BetTypeNames[betType]])]}
							action=""
							wrapLabel={true}
						/>
						<button on:click={applyFilter} class="h-8 btn btn-black"> Apply </button>
						<button
							on:click={() => {
								resetFilter();
							}}
							class="h-8 btn btn-muted"
						>
							Reset
						</button>
					</div>
					{#if loading}
						<div class="py-40">
							<Loading />
						</div>
					{:else}
						<div class="overflow-x-auto overflow-y-auto rounded">
							<table class="w-full">
								<thead>
									<tr class="text-xs text-left text-gray-500 uppercase">
										<th class="px-2 pt-5 pb-4 font-medium text-center">Ticket</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">Date</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">User</th>
										<th class="px-2 pt-5 pb-4 font-medium">Event</th>
										<th class="px-2 pt-5 pb-4 font-medium">Selection</th>
										<th class="px-2 pt-5 pb-4 font-medium">Bet</th>
										<th class="px-2 pt-5 pb-4 font-medium">Liability</th>
										<th class="px-2 pt-5 pb-4 font-medium">Return</th>
										<th class="px-2 pt-5 pb-4 font-medium">Net Win</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center">Status</th>
										<th class="px-2 pt-5 pb-4 font-medium text-center" />
									</tr>
								</thead>
								<tbody class="bg-white">
									{#if !$ExoticBetStore.count()}
										<tr>
											<td class="px-6 py-4 text-center border-t" colspan="10"> No exotic bets found. </td>
										</tr>
									{:else}
										{#each $ExoticBetStore.all() as bet (bet.id)}
											<tr class="hover:bg-gray-100 focus-within:bg-gray-100">
												<BetTickerRow {bet} />
											</tr>
										{/each}
									{/if}
								</tbody>
							</table>
						</div>
						<Pagination {links} on:click={changePage} className="my-3" />
					{/if}
				</div>
			</div>
		</div>
	</Modal>
{/if}
